import React from "react";
import useEventInfo from "gatsby-plugin-hfn-profile/components/PnrSummary/useEventInfo";
import { compareDateWithCurrentDate } from "sites-common/utils/FormatDate";
import applyProdQaConfig from "sites-common/utils/applyProdQaConfig";
import Seo from "../../../../components/seo";
import Layout from "../../../../layout";
import "../../../../assets/styles/special_event.scss";
import SpecialEventBanner from "../../../../components/special-event/SpecialEventBanner";
import SpecialEventRegistration from "../../../../components/special-event/SpecialEventRegistration";
import ExploreKanha from "../../../../components/special-event/ExploreKanha";
import DaajiMessage from "../../../../components/special-event/DaajiMessage";
import Heartintune from "../../../../components/special-event/Heartintune";
import { styleProp } from "../../../../assets/data/bandaraRegistration";

const eventId = applyProdQaConfig({
  prod: {
    id: "6b3ba9a6-84aa-40a4-86bc-3138493b4277",
  },
  qa: {
    id: "6b3ba9a6-84aa-40a4-86bc-3138493b4277",
  },
});

const SpecialEvent = () => {
  const { customConfig, data } = useEventInfo(eventId.id);
  const checkDate = data?.reg_ends
    ? compareDateWithCurrentDate(data.reg_ends)
    : false;

  const staticBannerContent = {
    title: "<h3>Coming together in Kanha</h3>",
    para: "<p>Join us with Daaji to celebrate Babuji`s birth anniversary on</p>",
    meditationTitleText: "Meditation Timings (IST) :",
    meditationTimings: [
      "29th April - 6:30 PM",
      "30th April - 6:30 AM, 11:00 AM, 6:30 PM",
      "1st May - 6:30 AM",
    ],
  };

  const bannerContent = customConfig?.bannerContent
    ? { ...staticBannerContent, ...customConfig.bannerContent }
    : staticBannerContent;

  return (
    <>
      <Seo
        title="Free Heartfulness Meditation Event | Daaji | Kanha Shanti Vanam"
        keyword="Heartfulness, Heartfulness Celebrations, Bhandara, Babuji Maharaj Birthday, April Bhandara, Kanha Shantivanam, Kanha Bhandara"
        description="Join Us Live Heartfulness Meditation Event with Daaji to Celebrate Babuji`s Birth Anniversary from Apr 29 to 1 May 2022 at Kanha Shanti Vanam. Register Now!"
      />
      <Layout isSticky wrapperClass="special_event">
        <div>
          <SpecialEventBanner
            eventId={eventId.id}
            styleProp={styleProp}
            bannerContent={bannerContent}
            data={data}
          />
          <SpecialEventRegistration
            eventId={eventId.id}
            styleProp={styleProp}
            endDate={checkDate}
            data={data}
          />
          <DaajiMessage eventInfo={customConfig?.daajiMessage || []} />
          <ExploreKanha />
          <Heartintune />
        </div>
      </Layout>
    </>
  );
};

export default SpecialEvent;
